import axios from './index';

class CustomerApi {
  static List = (data) => {
    console.log("data :::11 ", data);
    
    let query = '?';
    if (data.selectedStatusTypeValue) {
      query += `status=${data.selectedStatusTypeValue}&`;
    }
    if (data.selectedKycTypeValue) {
      query += `kyc_type=${data.selectedKycTypeValue}&`;
    }
    if (data.searchTerm) {
      query += `search=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static UserDelete = (data) => {
    const config = {
      headers: { accessToken: data.token },
      data: { id: data.id },
    };
    return axios.delete(`${base}/deletebyId`, config);
  };

  static Create = (data) => {
    let request = {
      name: data.name,
      email: data.email,
      phone_number: String(data.phoneNumber),
      user_type: 'CUSTOMER',
      status: data.status,
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    let request = {};
    if (data.name) request.name = data.name;
    if (data.email) request.email = data.email;
    if (data.phoneNumber) request.phone_number = String(data.phoneNumber);
    if (data.userType) request.user_type = data.userType;
    if (data.status) request.status = data.status;

    return axios.put(`${base}/${data.userId}`, request);
  };

  static getById = (id) => {
    return axios.get(`${base}/${id}`);
  };

  static generateOTP = (data) => {
    console.log('Data recieved in generate otp', data);
    let request = {
      user_id: data.id,
      aadhar_number: data.aadhaarNumber,
    };
    return axios.post(`${verificationbase}/generate-aadhar-otp`, request);
  };

  static verifyOTP = (data) => {
    console.log('Data recieved in verify otp', data);
    let request = {
      client_id: data.clientID,
      otp: data.otp,
      user_id: data.id,
    };
    return axios.post(`${verificationbase}/submit-aadhar-otp`, request);
  };
  static verifyPan = (data) => {
    console.log('Data recieved in verify pan', data);
    let request = {
      user_id: data.id,
      pan_number: data.panNumber,
    };
    return axios.post(`${verificationbase}/verify-pan`, request);
  };

  static getPortfolio = (id) => {
    return axios.get(`${portfoliobase}?user_id=${id}`);
  };

}

let base = 'auth/admin/customer';
let verificationbase = 'customer/admin';
let portfoliobase = 'customer/admin/portfolio';

export default CustomerApi;
